module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-angulo.6a3a0b4d.jpg";